// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cszz4","colBig":"styles_colBig__2HkkA","colSmall":"styles_colSmall__R_fh1","shopifyNameWrapper":"styles_shopifyNameWrapper__2Q3Mk"};